import React, { PureComponent } from 'react';
import { capitalize } from '../utilities/helperUtility';
import Translation from '../utilities/localizationUtility';
import VariantSelect from './components/VariantSelect';
import TermSelect from './components/TermSelect';
import Submit from './components/Submit';
import Price from './components/Price';
import Alert from '../components/Alert';
import ExceededMessage from "../components/exceeded_free_trial_message.js"

export default class CoursePage extends PureComponent {
  state = {
    termOptions: [],
  };

  onSubmit(e) {
    const { orderActions, cartActions } = this.props;
    const ele = e.target;
    const messages = [];

    orderActions
      .submitCourseOrder()
      .then((response) => {
        const { reservation } = response.data;
        if (reservation.items.some(x => x.status !== 'ok')) {
          let m = 'SCHEDULE CONFLICT PLEASE RELOAD PAGE';

          if (window.screen.width < 380) m = 'PLEASE RELOAD PAGE';
          this.alert.show('red', [m]);
          ele.innerText = m;
        } else {
          cartActions.addItems(reservation, ['Start', 'Finish', 'Term']);
        }
      })
      .catch((responsed) => {
        ele.disabled = false;
        const { response } = responsed;
        if (response && response.data) {
          const { data } = response;

          Object.keys(data).forEach((key) => {
            const name = key
              .split('_')
              .map(x => capitalize(x))
              .join('');
            messages.push(`${name} ${data[key]}`);
          });

          this.alert.show('red', ['SERVER ERROR']);
        } else {
          this.alert.show('red', ['SOMETHING WRONG']);
          throw responsed;
        }
      });
  }

  canBook() {
    const { termOptions } = this.state;
    const {
      frames: { flattenTimeSlots },
      order: { termSelected, variantSelected, variants },
    } = this.props;

    let option;
    let canBook = false;

    if (termOptions.length) {
      option = termOptions.find(o => o.id === termSelected.id);

      const { capacity } = variants[variantSelected];

      canBook = option && !option.disabled
    }
    return canBook;
  }

  render() {
    const { style, translation, variants, exceededTrialPlan } = this.props;
    const canBook = this.canBook();
    const enableVariantDropdown = !(variants.length === 1 && variants[0].title === 'Default Title');
    const t = new Translation(this.props);

    return (
      <div style={{ ...style.body, maxWidth: '450px', padding: '15px' }}>
        <h3 className="text-left" style={{ marginTop: '0' }}>
          {t.key('title')}
        </h3>

        {exceededTrialPlan &&
          <Alert unclosed={true} messages={[<ExceededMessage/>]} type="exceeded-trial-plan" />
        }

        {enableVariantDropdown && <VariantSelect priceSymbol={translation.priceSymbol} />}

        <div className="mt15">
          <TermSelect className="term-select" onOptionsChange={options => this.setState({ termOptions: options })} />
        </div>

        <Price />

        <Alert ref={ref => (this.alert = ref)} />

        <Submit canBook={canBook} onSubmit={e => this.onSubmit(e)} />
      </div>
    );
  }
}

CoursePage.propTypes = {};
